import {Injectable, ViewChild} from '@angular/core';
import {PlaceChange, StateInterface, UserProfileForm} from '@core/models';
import {FormGroup} from '@angular/forms';
import {BaseApiService} from '@core/api-services';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  @ViewChild('profile_form') selectedForm: { profileForm: FormGroup };
  public userData: UserProfileForm;
  public countryStates: StateInterface[];
  public countries: StateInterface[];
  public stateCities: { id: number, name: string }[];
  public loading = false;

  constructor(
    private baseApiService: BaseApiService
  ) {
  }

  private getStates(code: string): void {
    this.baseApiService.countriesService.getStatesByCountryCode(code)
      .subscribe(states => {
        this.countryStates = states;
        this.loading = false;
      });
  }

  private getCities(countryCode: string, stateCode: string): void {
    this.baseApiService.countriesService.getCitiesByStateCounties(countryCode, stateCode)
      .subscribe(cities => {
        this.stateCities = cities;
        this.loading = false;
      });
  }

  getCountries(): void {
    this.baseApiService.countriesService.getCounties()
      .subscribe((countries: StateInterface[]) => {
        this.countries = countries;
      });
  }

  placeChanged({country, state}: PlaceChange): void {
    this.loading = true;
    if (state) {
      this.stateCities = [];
      this.getCities(country, state);
      return;
    }
    this.countryStates = [];
    this.stateCities = [];
    this.getStates(country);
    return;
  }

  resetData(): void {
    this.userData = null;
    this.countryStates = null;
    this.stateCities = null;
  }
}
